<!--
  DIGITACAO DAS PARCELAS DO RECEBIMENTO DA VENDA

-->

<script>
import { arr, calcDesconto } from '../shared/numbers'

/*
params: {
    valorPagamento: 0,
    data: '',
    cheque: false,
    boleto: false,
    cartaoCredito: false,
    listParcelas: [],
    qtparcelas: 0,
}
*/


export default {
    props: {
        params: {},
        params_pdv: ''
    },

    data () {
        return {

            dadosParcela: {
                dias: 0,
                data: '',
                valor: 0,
                banco: '',
                documento: '',
            },
            parcelas: 0,
            listParcelas: [],

        }
    },

    computed: {
        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },
        nrExcedido: function () {
            if (!this.params.qtparcelas) {
                return false
            } else {
                return this.parcelas > this.params.qtparcelas
            }
        }
    },

    watch: {
        parcelas: function () {
            this.calculaParcelas()
        },

    },

    filters: {

    },

    methods: {
        cancelFormParcelas () {
            this.$emit('cancel')
        },

        handleConfirmaParcelas () {
            //AO CONFIRMAR AS PARCELAS, RETORNA O NUMERO DE PARCELAS E AS PARCELAS PARA O COMPONENTE PAI
            this.$emit('confirma', this.parcelas, this.listParcelas)
        },

        calculaParcelas () {
            //CALCULA PARCELAS DO PEDIDO

            this.listParcelas = [];
            let vlr = 0
            let soma = 0
            let parcela = {}
            if (this.parcelas > 12) {
                this.$erpToastWarning("O máximo permitido é 12")
                this.parcelas = 0
                return
            }

            if (this.parcelas == '0') {
                parcela = {...this.dadosParcela}
                parcela.dtv = this.params.data
                parcela.vlr = this.params.valorPagamento
                parcela.obspar = ''
                parcela.dias = 0
                this.listParcelas.push(parcela)
            } else {
                for (var x = 1; x <= this.parcelas; x++) {
                    parcela = {...this.dadosParcela}
                    parcela.dtv = this.$getDate()
                    parcela.dtv = this.$addMonths(parcela.dtv, x)
                    parcela.dias = x * 30
                    vlr = this.params.valorPagamento
                    vlr = arr(vlr / this.parcelas, 2, true)
                    parcela.vlr = vlr
                    parcela.obspar = ''
                    this.listParcelas.push(parcela)
                    soma = soma + vlr
                }
                if (soma != this.params.valorPagamento)
                  soma = this.params.valorPagamento - soma
                else 
                  soma = 0
                this.listParcelas[0].vlr = arr(this.listParcelas[0].vlr + soma, 2, true)
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        parcelasVlrChange(index) {
            //evento de controle de alteracao do valor da parcela
            //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
            if (this.parcelas <= 1) {
                return
            }
            let vlrparcial = 0
            let vlrnovaparcela = 0
            for (var x = 0; x <= index; x++) {
                vlrparcial = vlrparcial + parseFloat(this.listParcelas[x].vlr)
            }
            if (vlrparcial < this.params.valorPagamento) {
                vlrnovaparcela = (this.params.valorPagamento - vlrparcial) / (this.parcelas - (index + 1))
                vlrnovaparcela.toFixed(2)
            } else {
            }
            for (var x = index + 1; x <= this.listParcelas.length - 1; x++) {
                this.listParcelas[x].vlr = vlrnovaparcela
            }
        },

        parcelasDiasChange(index) {
            //evento de controle de alteracao do nr de dias de vencimento da parcela
            this.listParcelas[index].dtv = this.$addDays(this.pedv.data, this.listParcelas[index].dias)
        },

        parcelasBancoChange(index) {
            //evento para repetir o banco ou documento do cheque para os demais cheques abaixo
            if (index + 1 == this.parcelas) {
                return
            }

            let banco = this.listParcelas[index].banco
            let documento = this.listParcelas[index].documento

            for (var x = index + 1; x <= this.listParcelas.length - 1; x++) {
                this.listParcelas[x].banco = banco
                this.listParcelas[x].documento = documento
            }

        },

    },

    components: {

    },

    created () {
    },

    mounted () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.parcelas.focus()
        })
    }
}

</script>

<template>

<!-- FORM DE DIGITACAO DAS PARCELAS DO PAGAMENTO EM BOLETO OU CHEQUE -->
        <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important;">
            <div class="modal-content">
              <div class="modal-body d-flex flex-column vh-100" style="height: 500px!important; max-height: 100%; overflow-y: auto">
                <div class="row">
                    <div class="col-md-12 col-12">
                    <span class="lbl mb-4" style="font-size: 20px">
                        <strong>Parcelas {{ params.descricao }}</strong>
                    </span>
                    <button type="button" ref="ediitemclose" class="close" @click="cancelFormParcelas()" data-dismiss="modal"
                        aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                </div>
                <div class="row">
                    <form-field ref="valoraparcelar" col="3" :disabled="true" type="value" :precision="2" v-model="params.valorPagamento" label="Valor do Pagamento"></form-field>
                    <form-field ref="parcelas" v-model="parcelas" type="value" col="2" label="Qt de Parcelas"></form-field>
                </div>
                <alert v-if="nrExcedido" :close="false" type="warning" text="Quantidade de parcelas não permitida"></alert>
                <div class="row justify-content-md-center pl-2" v-if="parcelas > '0'">
                    <div class="col-md-2 col-3 ">
                        <v-label label="Dias"></v-label>
                    </div>
                    <div class="col-md-2 col-3">
                        <v-label label="Vencimento"></v-label>
                    </div>
                    <div class="col-md-2 col-3">
                        <v-label label="Valor"></v-label>
                    </div>
                    <!-- <div class="col-md-2 col-3">
                        <v-label label="Observações"></v-label>
                    </div>
                    <div v-if="params.cheque" class="col-md-2 col-3">
                        <v-label label="Banco"></v-label>
                    </div>
                    <div v-if="params.cheque" class="col-md-2 col-3">
                        <v-label label="Documento"></v-label>
                    </div> -->
                </div>
                <div class="row justify-content-md-center" v-for="(par, index) in listParcelas" :key="index">
                        <strong class="d-md-flex justify-content-center align-items-start pr-5 mr-2 text-center d-none" style="width:2px!important; padding:0px!important">
                            {{index+1}}
                        </strong>
                    <form-field v-model="par.dias" type="number" col="2"
                        :name="'dias'+index" :v-errors="errors" v-validate="metadata.pedvpar.dias.validator"
                        @input="parcelasDiasChange(index)"></form-field>
                    <form-field v-model="par.dtv" type="date" col="2"
                        :name="'dtv'+index" :v-errors="errors" v-validate="metadata.pedvpar.dtv.validator"></form-field>
                    <form-field v-model="par.vlr" type="value" col="2" :precision="2"
                        :name="'vlr'+index" :v-errors="errors" v-validate="metadata.pedvpar.vlr.validator"
                        @input="parcelasVlrChange(index)"></form-field>
                    <!-- <form-field v-model="par.obs" type="text" col="2"></form-field>
                    <form-field v-if="params.cheque" v-model="par.banco" type="number" col="2"
                        @input="parcelasBancoChange(index)"></form-field>
                    <form-field v-if="params.cheque" v-model="par.documento" type="text" col="2"
                        @input="parcelasBancoChange(index)"></form-field> -->
                </div>
                <div class="row mt-auto">
                    <div class="col-md-12 col-12">
                        <v-button label="Confirmar" title="" :disabled="parcelas <= 0" @click="handleConfirmaParcelas"></v-button>
                        <v-button label="Cancelar" title="" @click="cancelFormParcelas"></v-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>


</template>





<style>



</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-parcelas-form.vue